import {
  V1_ADDRESS_WITH_ZIP_CODE,
  V1_BASIC_INFORMATION_PATH,
  V1_CANDIDATES_VERIFY_ACCOUNT,
  V1_CITY_PATH,
  V1_COUNTRY_PATH,
  V1_EMPLOYMENT_TYPE_PATH,
  V1_CANDIDATE_EXPERIENCE_PATH,
  V1_GRADUATION_CLASSIFICATION_PATH,
  V1_INCOME_PATH,
  V1_INDUSTRIES_PATH,
  V1_JOB_FEATURES_PATH,
  V1_JOB_SEARCH_PATH,
  V1_LANGUAGE_LEVEL_PATH,
  V1_LANGUAGE_PATH,
  V1_OCCUPATION_PATH,
  V1_OFFER_REPORT_PATH,
  V1_PREFECTURE_PATH,
  V1_PROFILE_PATH,
  V1_REGISTRATION_PATH,
  V1_RESUME_EDUCATION_PATH,
  V1_BASIC_INFO_PATH,
  V1_RESUME_OPTIONAL_INFORMATION_PATH,
  V1_RESUME_SKILL_PATH,
  V1_SCHOOL_CATEGORY_PATH,
  V1_SEARCH_JOB_PATH,
  V1_SESSION_PATH,
  V1_SIGN_UP_PATH,
  V1_SKILL_PATH,
  V1_WORK_HISTORY_PATH,
  V1_COMPLETED_SIGN_UP_PATH,
  V1_BLOCKED_COMPANIES_PATH,
  V1_JOB_SEARCH_CONDITION,
  V1_SAVE_CONDITION_JOB_SEARCH,
  V1_CANDIDATE_RESET_PASSWORD,
  V1_CANDIDATES_VERIFY_TOKEN,
  V1_CANDIDATES_SAVE_ACCOUNT,
  V1_CANDIDATE_RESEND_MAIL,
  V1_EXPERIENCE_PATH,
  V1_ADDITIONAL_INFO_PATH,
  V1_CAREER_PATH,
  V1_DESIRED_CONDITION_PATH,
} from '@/constant/routers/path';
import request from '@/services/http.service';
import { OfferReport } from '@/types/models/offerReport';
import { JobSearch, SaveJobSearch } from '@/types/pages/SearchJob';
import { LocationQueryValue } from 'vue-router';
import { ConfirmPassword } from '@/types/api/confirmPassword';

export const getBasicInformation = (signature?: string) => {
  return request(V1_BASIC_INFORMATION_PATH, {
    method: 'GET',
    params: { signature: signature },
  });
};

export const getJobSearchCondition = (signature?: string) => {
  return request(V1_JOB_SEARCH_CONDITION, {
    method: 'GET',
    params: { signature: signature },
  });
};

export const getWorkHistory = (signature?: string) => {
  return request(V1_WORK_HISTORY_PATH, {
    method: 'GET',
    params: { signature: signature },
  });
};

export const getResumeEducation = (signature?: string) => {
  return request(V1_RESUME_EDUCATION_PATH, {
    method: 'GET',
    params: { signature: signature },
  });
};

export const getResumeExperience = (email?: string, signature?: string) => {
  return request(V1_CANDIDATE_EXPERIENCE_PATH, {
    method: 'GET',
    params: { email: email, signature: signature },
  });
};

export const getResumeSkills = (signature?: string) => {
  return request(V1_RESUME_SKILL_PATH, {
    method: 'GET',
    params: { signature: signature },
  });
};

export const getBasicInfo = (email?: string, signature?: string) => {
  return request(V1_BASIC_INFO_PATH, {
    method: 'GET',
    params: { email: email, signature: signature },
  });
};

export const getAdditionalInfo = (signature?: string) => {
  return request(V1_ADDITIONAL_INFO_PATH, {
    method: 'GET',
    params: { signature: signature },
  });
};

export const getCareer = (signature?: string) => {
  return request(V1_CAREER_PATH, {
    method: 'GET',
    params: { signature: signature },
  });
};

export const getDesiredCondition = (signature?: string) => {
  return request(V1_DESIRED_CONDITION_PATH, {
    method: 'GET',
    params: { signature: signature },
  });
};

export const createAccountEmail = (data: any) => {
  return request(V1_SIGN_UP_PATH, {
    method: 'POST',
    data,
  });
};

export const getOccupations = () => {
  return request(V1_OCCUPATION_PATH, {
    method: 'GET',
  });
};

export const getCountries = () => {
  return request(V1_COUNTRY_PATH, {
    method: 'GET',
  });
};

export const getPrefectures = () => {
  return request(V1_PREFECTURE_PATH, {
    method: 'GET',
  });
};

export const getCitiesByPrefectures = (prefectureID?: number) => {
  return request(`${V1_CITY_PATH}?prefecture_id=${prefectureID}`, {
    method: 'GET',
  });
};

export const getCities = () => {
  return request(V1_CITY_PATH, {
    method: 'GET',
  });
};

export const getProfile = () => {
  return request(V1_PROFILE_PATH, {
    method: 'GET',
  });
};

export const updateProfile = (data: any) => {
  return request(V1_PROFILE_PATH, {
    method: 'PATCH',
    headers: { 'Content-Type': 'multipart/form-data' },
    data,
  });
};

export const getIncomes = () => {
  return request(V1_INCOME_PATH, {
    method: 'GET',
  });
};

export const getEmploymentTypes = (condition: boolean) => {
  return request(V1_EMPLOYMENT_TYPE_PATH, {
    method: 'GET',
    params: { search_condition: condition },
  });
};

export const getSchoolCategory = () => {
  return request(V1_SCHOOL_CATEGORY_PATH, {
    method: 'GET',
  });
};

export const getSkills = () => {
  return request(V1_SKILL_PATH, {
    method: 'GET',
  });
};

export const getIndustries = () => {
  return request(V1_INDUSTRIES_PATH, {
    method: 'GET',
  });
};

export const getMasterLanguageLevel = () => {
  return request(V1_LANGUAGE_LEVEL_PATH, {
    method: 'GET',
  });
};

export const getMasterLanguage = () => {
  return request(V1_LANGUAGE_PATH, {
    method: 'GET',
  });
};

export const getGraduationClassifications = () => {
  return request(V1_GRADUATION_CLASSIFICATION_PATH, {
    method: 'GET',
  });
};

export const registrationData = (data: any) => {
  return request(V1_REGISTRATION_PATH, {
    method: 'POST',
    data,
  });
};

export const createBasicInformation = (data: any) => {
  return request(V1_BASIC_INFORMATION_PATH, {
    method: 'POST',
    data,
  });
};

export const createWorkHistories = (data: any) => {
  return request(V1_WORK_HISTORY_PATH, {
    method: 'POST',
    data,
  });
};

export const createAdditionalInfo = (data: any) => {
  return request(V1_ADDITIONAL_INFO_PATH, {
    method: 'POST',
    data,
  });
};

export const createCareer = (data: any) => {
  return request(V1_CAREER_PATH, {
    method: 'POST',
    data,
  });
};

export const createDesiredCondition = (data: any) => {
  return request(V1_DESIRED_CONDITION_PATH, {
    method: 'POST',
    data,
  });
};

export const saveResumeEducation = (data: any) => {
  return request(V1_RESUME_EDUCATION_PATH, {
    method: 'POST',
    data,
  });
};

export const saveExperience = (data: any) => {
  return request(V1_CANDIDATE_EXPERIENCE_PATH, {
    method: 'POST',
    data,
  });
};

export const saveResumeSkill = (data: any) => {
  return request(V1_RESUME_SKILL_PATH, {
    method: 'POST',
    data,
  });
};

export const saveBasicInfo = (data: any) => {
  return request(V1_BASIC_INFO_PATH, {
    method: 'POST',
    data,
  });
};

export const saveResumeOptionalInformation = (data: any) => {
  return request(V1_RESUME_OPTIONAL_INFORMATION_PATH, {
    method: 'POST',
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    data,
  });
};

export const login = (data: any) => {
  return request(V1_SESSION_PATH, {
    method: 'POST',
    data,
  });
};

export const saveAccessToken = (data: any) => {
  return request(V1_SESSION_PATH, {
    method: 'Patch',
    data,
  });
};

export const getJobFeature = () => {
  return request(V1_JOB_FEATURES_PATH, {
    method: 'GET',
  });
};

export const getExperiences = () => {
  return request(V1_EXPERIENCE_PATH, {
    method: 'GET',
  });
};

export const createJobSearchCondition = (data: any) => {
  return request(V1_JOB_SEARCH_PATH, {
    method: 'POST',
    data,
  });
};

export const saveJobSearchCondition = (data: SaveJobSearch) => {
  return request(V1_SAVE_CONDITION_JOB_SEARCH, {
    method: 'POST',
    data,
  });
};

export const addressWithZipCode = (zipCode?: string) => {
  return request(`${V1_ADDRESS_WITH_ZIP_CODE}?zip_code=${zipCode}`, {
    method: 'GET',
  });
};

export const createCandidateOfferReport = (data: OfferReport) => {
  return request(V1_OFFER_REPORT_PATH, {
    method: 'POST',
    data,
  });
};

export const searchJob = (data: JobSearch) => {
  return request(V1_SEARCH_JOB_PATH, {
    method: 'POST',
    data,
  });
};

export const verifyAccount = (signature: string | null | LocationQueryValue[]) => {
  return request(`${V1_CANDIDATES_VERIFY_ACCOUNT}/${signature}`, {
    method: 'GET',
  });
};

export const saveCandidateAccount = (
  password: string,
  token: string | null | LocationQueryValue[]
) => {
  return request(V1_CANDIDATES_SAVE_ACCOUNT, {
    method: 'POST',
    data: { token: token, password: password },
  });
};

export const saveCandidateSession = (signature: string | null) => {
  return request(V1_COMPLETED_SIGN_UP_PATH, {
    method: 'POST',
    data: { token: signature },
  });
};

export const getCompanyListByName = (queryString: string | null) => {
  return request(V1_BLOCKED_COMPANIES_PATH, {
    method: 'GET',
    params: { blocked_company_name: queryString },
  });
};

export const forgotPassword = (email: string) => {
  return request(V1_CANDIDATE_RESET_PASSWORD, {
    method: 'POST',
    data: { email: email },
  });
};

export const resetPassword = (data: ConfirmPassword) => {
  return request(V1_CANDIDATE_RESET_PASSWORD, {
    method: 'PATCH',
    data,
  });
};

export const verifyToken = (signature: string | null | LocationQueryValue[], type: string) => {
  return request(V1_CANDIDATES_VERIFY_TOKEN, {
    method: 'POST',
    data: { token: signature, type: type },
  });
};

export const resendMail = (email: string) => {
  return request(V1_CANDIDATE_RESEND_MAIL, {
    method: 'GET',
    params: { email: email },
  });
};
